<template>
  <div>
    <div class="my_coupon">
      <div class="my_coupon_title">优惠券历史</div>
      <div class="clearfix_ my_coupon_box">
        <div class="fl my_coupon_num">{{total}}<span style="font-size:18px;color:#666;">&nbsp;&nbsp;张</span></div>
        <div class="fl clearfix_ my_coupon_btn">
          <div @click="goToCouponList(tenantId)" class="fl">领券中心>></div>
          <div @click="goToHistoryCoupon(tenantId)" class="fl">优惠券历史>></div>
        </div>
        <div class="fr">
          <el-select style="width:142px;margin-right:30px;" v-model="status" @change="selectCoupon(status)" placeholder="请选择">
            <el-option label="已使用" value="1"> </el-option>
            <el-option label="已过期" value="2"> </el-option>
          </el-select>
        </div>
      </div>
    </div>
    <div class="my_coupon_list clearfix_">
      <div style="width:240px;" v-for="(item,index) in couponList" :key="index" class="my_coupon_list_item fl">
        <div v-if="status==1" class="my_coupon_list_item_time">使用单号：{{item.scode}}</div>
        <div v-if="status==2" class="my_coupon_list_item_time">过期时间：{{item.pastDate}}</div>
        <div style="width:240px;height:65px;" class="coupon_list_item_box">
          <div class="coupon_history_goto" @click="goToOrderDeatil(item.retailOrderId)"></div>
          <img class="_coupon_use_" v-if="status==1" :src="use" alt="">
          <img class="_coupon_overdue_" v-if="status==2" :src="overdue" alt="">
          <div style="width:240px;height:65px;" class="coupon_list_item_box_img">
            <img style="width:240px;height:65px;" v-show="parseFloat(item.price)>0&&parseFloat(item.price)<50" :src="newCouponBg1" alt="">
            <img style="width:240px;height:65px;" v-show="parseFloat(item.price)>=50&&parseFloat(item.price)<100"  :src="newCouponBg2" alt="">
            <img style="width:240px;height:65px;" v-show="parseFloat(item.price)>=100"  :src="newCouponBg3" alt="">
          </div>
          <div class="new_coupon_list_item_box_rmb">¥</div>
          <div v-show="item.price.length==1" class="new_coupon_list_item_box_price">{{item.price}}</div>
          <div v-show="item.price.length==2" class="new_coupon_list_item_box_price_active_len2">{{item.price}}</div>
          <div v-show="item.price.length==3" class="new_coupon_list_item_box_price_active_len3">{{item.price}}</div>
          <div v-show="item.price.length>=4" class="new_coupon_list_item_box_price_active_len4">{{item.price}}</div>
          <div style="font-size:14px;top:10px;left:105px;" class="coupon_list_item_box_conditions"><span>{{item.condition}}</span> <span style="color:#a75212;">{{item.goodsNum}}</span> <span>{{item.method}}可用</span></div>
          <div style="font-size:12px;top:40px;left:20px;color:#fff;" class="coupon_list_item_box_scope">{{item.useRange}}</div>
          <div class="my_coupon_item_time">{{item.pastDate}}</div>
          <div :style="{'color': (status==2 ? '#ccc':'#f12002')}" style="top:1px;right:1px;width:20px;height:auto;line-height:14px;background:#fff;text-align:center;cursor: pointer;border-left:1px dashed #ccc;padding:17px 2px;" @click="goToOrderDeatil(item.retailOrderId)" class="coupon_list_item_box_use">查看</div>
        </div>
      </div>
    </div>
    <div class="no_data" v-if="total==0">暂无数据</div>
    <div class="my_coupon_pages">
      <div>
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page.sync="page"
          :page-size="12"
          layout="prev, pager, next, jumper"
          :total="this.total">
        </el-pagination>
      </div> 
    </div>
  </div>
</template>
<script>
import '../../assets/css/reset.css'
import axios from 'axios'
import Qs from 'qs'
import { ip,overtime } from '../../assets/js/public.js'
export default {
  data(){
    return {
      newCouponBg1:require('../../assets/img/coupon240_1.png'),
      newCouponBg2:require('../../assets/img/coupon240_2.png'),
      newCouponBg3:require('../../assets/img/coupon240_3.png'),
      myCoupon:require('../../assets/img/my_coupon.png'),
      overdue:require('../../assets/img/be_overdue.png'),
      use:require('../../assets/img/use.png'),
      page:1,
      total:null,
      couponList:[],
      tenantId:'',
      status:'1',
      couponNum:0
    }
  },
  mounted:function(){
    this.tenantId=this.$route.query.tenantId
    this.getMyCoupon(this.page)
  },
  methods:{
    goToOrderDeatil:function(orderId){
      var t_=this
      if(t_.status==2)return
      var href=this.$router.resolve({name:'orderDetails',query:{id:orderId}})
      return window.open(href.href,'_blank')
    },
    goToCouponList:function(tenantId){
      var t_=this
      var href=this.$router.resolve({name:'couponList',query:{tenantId:tenantId}})
      return window.open(href.href,'_blank')
    },
    selectCoupon:function(val){
      var t_=this
      t_.status=val
      t_.page=1
      t_.couponList=[]
      t_.getMyCoupon(t_.page)
    },
    goToHistoryCoupon:function(tenantId){
      var t_=this
      var href=this.$router.resolve({name:'historyCoupon',query:{tenantId:tenantId}})
      return window.open(href.href,'_blank')
    },
    handleSizeChange(val){

    },
    handleCurrentChange(val) {
      this.page=val
      this.couponList=[]
      this.getMyCoupon(val)
    },
    getMyCoupon:function(){
      var t_=this
      var data0bj=Qs.stringify({
        page:t_.page,
        pagesize:12,
        channel:2,
        tamp:localStorage.tamp?localStorage.tamp:'',
        tenantId:t_.$route.query.tenantId,
        status:t_.status
      })
      axios.post(`${ip}formWorkInterface/getMemberCouponList`,data0bj).then(res =>{
        if(res.data.code==300){
          var href=this.$router.resolve({name:'err404',query:{txt:res.data.message}})
          return window.open(href.href,'_blank')
        }
        if(res.data.code==0){
          res.data.couponList.forEach(function(item,index){
            item.price=item.price.toString()
          },t_)
          t_.couponList=res.data.couponList
          t_.couponNum=res.data.num
          t_.status=res.data.status
          t_.total=res.data.total
        }
      })
    }
  }
}
</script>
<style>
  .my_coupon{
    border-bottom:2px solid #ccc;
  }
  .my_coupon_title{
    padding: 20px 0 40px 0;
    font-size: 20px;
  }
  .my_coupon_num{
    color:#f12002;
    font-size: 30px;
    margin-left: 130px;
  }
  .my_coupon_btn{
    margin-left: 160px;
    margin-top: 15px;
    cursor: pointer;
  }
  .my_coupon_btn div:nth-child(2){
    margin-left: 65px;
  }
  .my_coupon_box{
    padding-bottom: 35px;
  }
  .my_coupon_list{
    padding: 20px 0;
  }
  .my_coupon_list_item{
    width: 330px;
    margin: 0 20px 20px 0;
  }
  .my_coupon_list_item:nth-child(4n){
    margin: 0 0 20px 0;
  }
  .my_coupon_list_item_time{
    margin-left: 10px;
    margin-bottom: 15px;
  }
  .coupon_list_item_box{
    width:330px;
    height:104px;
    position: relative;
  }
  .coupon_list_item_box_img{
    width:330px;
    height:104px;
    position: absolute;
    top:0;
    left:0;
  }
  .coupon_list_item_box_img img{
    width:330px;
    height:104px;
  }
  .my_coupon_list_item .new_coupon_list_item_box_rmb{
    position: absolute;
    top:21px;
    left:10px;
    color:#fff;
    font-size: 20px;
  }
  .my_coupon_list_item .new_coupon_list_item_box_price{
    position: absolute;
    top:10px;
    left: 36px;
    color:#fff;
    font-size:34px;
  }
  .my_coupon_list_item .new_coupon_list_item_box_price_active_len2{
    position: absolute;
    top:10px;
    left: 29px;
    color:#fff;
    font-size:34px;
  }
  .my_coupon_list_item .new_coupon_list_item_box_price_active_len3{
    position: absolute;
    top:13px;
    left: 24px;
    color:#fff;
    font-size:32px;
  }
  .my_coupon_list_item .new_coupon_list_item_box_price_active_len4{
    position: absolute;
    top:17px;
    left: 23px;
    color:#fff;
    font-size:26px;
  }
  .coupon_list_item_box_conditions{
    position: absolute;
    top:15px;
    left:165px;
    font-size:18px;
    overflow: hidden;
    text-overflow:ellipsis;
    white-space: nowrap;
    font-weight: 900;
    color:#66604a;
  }
  .coupon_list_item_box_scope{
    position: absolute;
    top:57px;
    left:165px;
    font-size:16px;
    height: 22px;
    line-height: 22px;
  }
  .coupon_list_item_box_use{
    position: absolute;
    top:57px;
    right:20px;
    width: 72px;
    height: 22px;
  }
  ._coupon_use_,._coupon_overdue_{
    width: 50px;
    height: 50px;
    position: absolute;
    top:5px;
    right: 50px;
    z-index: 9;
  }
  .my_coupon_item_time{
    position: absolute;
    top:40px;
    left:105px;
    color:#ababab;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    width: 100px;
  }
  .no_data{
    text-align: center;
    padding: 20px 0;
  }
  .coupon_history_goto{
    width: 214px;
    height: 65px;
    position: absolute;
    top:0;
    left:0;
    z-index: 9;
    cursor: pointer;
  }
  .my_coupon_pages{
    text-align: center;
    padding-bottom: 10px;
  }
  .my_coupon_pages .el-pagination__jump{
    margin-top: -9px;
  }
  .my_coupon_pages .el-pagination__jump .el-pagination__editor{
    top:9px;
  }
</style>



// WEBPACK FOOTER //
// src/components/coupon/history_coupon.vue